import styled from 'styled-components'

export const FlexRow = styled.div<{
  align?: string
  justify?: string
  margin?: string
  width?: string
  padding?: string
  wrap?: string
  backgroundColor?: string
}>`
  display: flex;
  justify-content: ${({ justify }) => justify || 'center'};
  align-items: ${({ align }) => align || 'center'};
  margin: ${({ margin }) => margin || '0'};
  width: ${({ width }) => width};
  padding: ${({ padding }) => padding};
  flex-wrap: ${({ wrap }) => wrap};
  background-color: ${({ backgroundColor }) => backgroundColor};
`

export const FlexCol = styled.div<{
  align?: string
  justify?: string
  margin?: string
  padding?: string
  width?: string
  backgroundColor?: string
}>`
  display: flex;
  flex-direction: column;
  justify-content: ${({ justify }) => justify || 'center'};
  align-items: ${({ align }) => align || 'center'};
  margin: ${({ margin }) => margin || '0'};
  padding: ${({ padding }) => padding};
  width: ${({ width }) => width};
  background-color: ${({ backgroundColor }) => backgroundColor};
`
